<footer class="bg-[#343a40]">
    <div class="px-4 lg:px-8">
        <div
            class="flex flex-col lg:flex-row lg:justify-between items-center justify-start gap-2 border-t-2 border-gray-400 text-gray-300 text-base min-h-[5rem] lg:min-h-[4rem]"
        >
            <span>
                Want to learn more and use the voices in your apps? Contact us
                at
                <a
                    href="mailto:office@zevo-tech.com"
                    target="_blank"
                    class="text-teal-500"
                    >office@zevo-tech.com</a
                >.
            </span>
            <span class="flex items-center gap-2">
                © 2026 Zevo Technology S.R.L. All rights reserved
                <span
                    class="relative inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 text-gray-400 text-[10px] cursor-help hover:border-gray-200 hover:text-gray-200 transition-colors"
                    (mouseenter)="showTooltip = true"
                    (mouseleave)="showTooltip = false"
                >
                    i
                    <div
                        *ngIf="showTooltip"
                        class="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-800 text-white text-xs rounded shadow-lg whitespace-nowrap z-50"
                    >
                        <div class="font-semibold mb-1">Version: {{ version }}</div>
                        <div>API: {{ apiServiceName }}</div>
                        <div>Backend: {{ backendServiceName }}</div>
                        <div class="absolute top-full right-2 border-4 border-transparent border-t-gray-800"></div>
                    </div>
                </span>
            </span>
        </div>
    </div>
</footer>
